export default function and(...args: any[]) {
  return !!(args.length && args.every((arg) => arg));
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    and: typeof and;
  }
}
